<template>
    <div>
        <v-toolbar class="header-element mt-2" dense>
            <v-toolbar-title>Respuesta</v-toolbar-title>
        </v-toolbar>
        <v-card>
            <v-flex v-if="hasComments" class="comments-area">
                <v-subheader>Comentarios:</v-subheader>
                    <v-card v-for="comment in settlement.settlementComments" :key="comment.id" class="comment-area">
                        <div class="font-weight-bold">{{ comment.modified }} - {{comment.autor.lastName}} {{comment.autor.firstName}}:</div>
                        {{ comment.texto }}
                        <template v-if="comment.assets.length > 0">
                            <div v-for="asset in comment.assets" :key="asset.id">
                                <a :href="asset.url" target="_blank">{{ getAttachmentName(asset.name) }}</a>
                            </div>
                        </template>
                    </v-card>
            </v-flex>
            <v-flex v-if="!hasComments" class="comments-area">
                <v-subheader>Comentarios:</v-subheader>
                <div class="comment-area custom-message">
                    Aún no se registraron comentarios
                </div>
            </v-flex>
            <template v-if="settlement.canEdit">
                <v-flex>
                    <v-divider></v-divider>
                    <v-subheader>Escribir comentario:</v-subheader>
                    <v-select v-if="$store.getters.isSafRole" v-model="status" :items="statuses" :error-messages="statusErrors"
                              label="Estado" class="write-area" solo outline flat no-data-text="No hay datos disponibles">
                    </v-select>
                    <v-textarea class="write-area" single-line outline
                                v-model="comment"
                                :error-messages="commentErrors"
                                label="Agregar comentario"
                                required>
                    </v-textarea>
                </v-flex>
                <v-flex v-if="!$store.getters.isSafRole">
                    <AttachFile ref="fileInput" @upload="uploadFiles" description class="text-area"></AttachFile>
                    <div v-if="saving">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                        <v-subheader class="right">Cargando, por favor espere.</v-subheader>
                    </div>
                </v-flex>
                <v-btn v-if="!$store.getters.isSafRole"
                       @click="openFileDirectory" color="primary" class="buttons-area" :disabled="saving">Agregar adjuntos</v-btn>
                <v-btn @click="uploadAllFiles" color="primary" class="buttons-area" :disabled="saving">Enviar</v-btn>
            </template>
        </v-card>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import { required, requiredIf } from 'vuelidate/lib/validators'
import AttachFile from '../../../common/ui/AttachFile'

const RECHAZADA = 1
const APROBADA = 2

export default {
  mixins: [validationMixin, s3UploadMixin],

  validations () {
    return {
      comment: { required },
      status: { required: requiredIf(() => { return this.$store.getters.isSafRole }) }
    }
  },

  props: {
    settlement: Object
  },

  components: {
    AttachFile
  },

  data: () => ({
    loading: false,
    saving: false,
    comment: '',
    status: null,
    files: []
  }),

  computed: {
    hasComments () {
      return this.settlement.settlementComments.length > 0
    },
    statuses () {
      return [
        { text: 'Rechazada', value: RECHAZADA },
        { text: 'Aprobada', value: APROBADA }
      ]
    },
    commentErrors () {
      return this.getRequiredErrors('comment', 'Debe ingresar un comentario')
    },
    statusErrors () {
      return this.getRequiredErrors('status', 'Debe seleccionar un estado')
    }
  },

  methods: {
    getRequiredErrors (property, message = 'Este campo es requerido.') {
      const errors = []
      if (!this.$v[property].$dirty) return errors
      !this.$v[property].required && errors.push(message)
      return errors
    },
    getClubPayload () {
      return {
        'texto': this.comment,
        'assets': this.assets,
        'settlement': this.settlement.id
      }
    },
    getSafPayload () {
      let statuses = this.statuses
      return {
        'estado': this.status,
        'texto': this.comment ? (statuses[this.status - 1].text + ': ' + this.comment) : statuses[this.status - 1].text,
        'settlement': this.settlement.id
      }
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        const payload = this.$store.getters.isSafRole ? this.getSafPayload() : this.getClubPayload()
        this.axios
          .post('settlement/response', payload)
          .then((response) => {
            this.saving = false
            this.$emit('updateAfterRequest')
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    }
  }
}
</script>

<style scoped>
    .header-element {
        background-color: #293968;
        color: white;
    }
    .text-area {
        padding: 16px;
    }
    .write-area {
        padding-left: 16px;
        padding-right: 16px;
    }
    .comment-area {
        margin: 16px;
        padding-left: 10px;
    }
    .comments-area {
        padding-bottom: 16px;
    }
    .buttons-area {
        margin-left: 16px;
        margin-bottom: 16px;
    }
    .custom-message {
        padding: 10px;
        font-weight: bolder;
        border: 1px solid gray;
        margin-top: 13px;
    }
</style>
